import { Button } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import GenerateMenu from './GenerateMenu';
import { GeneratedDocumentType } from './generatedDocumentTypes';

type Props = {
  documentTypeFilter?: GeneratedDocumentType;
  openFlow: (documentType: GeneratedDocumentType) => void;
  buttonText: string;
};

// On a filtered sub-tab the type is known, so "Generate" produces that type
// directly; the unfiltered view keeps the dropdown to pick a type.
export default function GenerateDocumentsControl({
  documentTypeFilter,
  openFlow,
  buttonText,
}: Props) {
  if (documentTypeFilter) {
    return (
      <Button
        variant="primary"
        size="sm"
        h={36}
        fw={FONT_WEIGHTS.semibold}
        rightSection={<IconPlus size={16} />}
        onClick={() => openFlow(documentTypeFilter)}
        data-testid="generate-button"
      >
        {buttonText}
      </Button>
    );
  }

  return (
    <GenerateMenu
      openSuitabilityFlow={() => openFlow('suitability-report')}
      openAgendaFlow={() => openFlow('meeting-agenda')}
      openDataExportFlow={() => openFlow('data-export')}
      openMeetingNote={() => openFlow('meeting-note')}
      buttonText={buttonText}
    />
  );
}
